import { isNumber } from './isNumber';

export function tryParseInt(value: string | number | undefined | null): number | undefined {
  if (isNumber(value)) {
    return value;
  }
  if (!value) {
    return undefined;
  }
  const parsedValue = parseInt(value, 10);
  return Number.isNaN(parsedValue) ? undefined : parsedValue;
}
